/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/AuthContext';
import { useAppStore } from '../store/AppContext';

import { AccessType, NotificationsType } from '../types/Types';

import { StorageHelper } from '../utils/StorageHelper';
import { GtmManager } from '../utils/GtmManager';
import { LanguageHelper } from '../utils/LanguageHelper';
import HeaderEroski from './HeaderEroski';
import HeaderCaprabo from './HeaderCaprabo';
import NotFound from '../pages/NotFound';
import { HostProvider } from '../utils/HostProvider';

// const defaultLang: string | null = localStorage.getItem('i18nextLng');
const Header: FC = () => {
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const { t } = useTranslation();

  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const location = useLocation();
  const [ipValue, setIpValue] = useState('' as string);

  const { userName, moneda, trustApp } = dataUser.user;
  const { access, lang } = dataApp;
  const [languaje, setLanguaje] = useState(lang);
  const [miCuenta, setMiCuenta] = useState<AccessType[]>([]);
  const [miCuentaText, setMiCuentaText] = useState('');
  const [ventajas, setVentajas] = useState<AccessType[]>([]);
  const [solicitarTarjeta, setSolicitarTarjeta] = useState<AccessType>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [notifications, setNotifications] = useState<NotificationsType>(
    {} as NotificationsType,
  );
  const [menuMobile, setMenuMobile] = useState(false);
  const [showMiCuenta, setShowMiCuenta] = useState(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [changeLng, SetChangeLng] = useState(false);
  const [sessionVales, setSessionVales] = useState(
    parseInt(sessionStorage.getItem('sessionVales') as string, 10),
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cantVales, setCantVales] = useState(
    parseInt(sessionStorage.getItem('numCuponesAct') as string, 10),
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showCantVales, setShowCantValues] = useState(
    parseInt(sessionStorage.getItem('showCuponesAct') as string, 10),
  );
  const [show, setShow] = useState(false);

  const APP_BASE_URL = isEroski
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_CAPRABO;

  const isEcommerceBot = StorageHelper.isEcommerceBot();

  useEffect(() => {
    if (typeof access?.ventajas !== 'undefined') {
      setVentajas(_.uniqWith(access?.ventajas, _.isEqual));
    }
    if (typeof access?.solicitarTarjeta !== 'undefined') {
      if (!dataUser.user.isFB) {
        setSolicitarTarjeta(access?.solicitarTarjeta);
      }
    }
    if (
      access?.notificacionPojo != null &&
      typeof access?.notificacionPojo !== 'undefined'
    ) {
      setNotifications(access?.notificacionPojo);
      if (sessionVales === 0) {
        setCantVales(access?.notificacionPojo.numero);
        setSessionVales(1);
        sessionStorage.setItem(
          'numCuponesAct',
          access?.notificacionPojo.numero > 0 ? '1' : '0',
        );
        sessionStorage.setItem(
          'showCuponesAct',
          access?.notificacionPojo.numero > 0 ? '1' : '0',
        );
        sessionStorage.setItem('sessionVales', '1');
      }
      setShowCantValues(
        parseInt(sessionStorage.getItem('showCuponesAct') as string, 10),
      );
    }

    if (typeof access?.miCuenta !== 'undefined') {
      let mc = access?.miCuenta;
      if (mc.length > 0) {
        mc = _.uniqWith(mc, _.isEqual);
        setMiCuentaText(mc[0].descripcion);
        delete mc[0];
        setMiCuenta(mc);
      }
      // eslint-disable-next-line no-prototype-builtins
      if (access.hasOwnProperty('locale') !== undefined)
        setLanguaje(access.locale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  useEffect(() => {
    console.log('useEffect');
    console.log(dataApp.gtmFlag);

    if (dataApp.gtmFlag) {
      console.log('entro al gtm');
      console.log(dataApp.gtmFlag);
      GtmManager.createHeadScript(dataUser);
      const scriptElement = document.querySelector('script[src="gtm_script"]');
      if (scriptElement) {
        scriptElement.remove();
      }
      dataApp.changeGtmFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser, dataApp.gtmFlag]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setLanguajeHadler = (ln: string) => {
    /**
     * Reload access user
     * */
    SetChangeLng(true);
    setLanguaje(ln);
    LanguageHelper.setLanguage(ln);
    // dataApp.changeLang(ln);
    dataApp.loadHeader(ln);
  };

  const removeNotification = () => {
    setShow(false);
  };
  const notification = document.querySelector(
    'div.block-link--dropdown.notification',
  );

  useEffect(() => {
    if (languaje !== i18n.language) {
      if (!changeLng) {
        setLanguajeHadler(i18n.language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeLng, setLanguajeHadler, languaje, location, show]);

  if (show) {
    document.body.addEventListener('click', removeNotification, false);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    notification.addEventListener('mouseover', () => {
      document.body.removeEventListener('click', removeNotification, false);
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    notification.addEventListener('mouseout', () => {
      document.body.addEventListener('click', removeNotification, false);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const showNotification = (cleanBell: boolean) => {
    setShow(!show);
    if (!cleanBell) {
      setCantVales(0);
      sessionStorage.setItem('numCuponesAct', '0');
    } else {
      setShowCantValues(0);
      setCantVales(0);
      sessionStorage.setItem('numCuponesAct', '0');
      sessionStorage.setItem('showCuponesAct', '0');
    }
  };

  const getUrl = (items: AccessType) => {
    if (items.url.slice(0, 4) === 'http') return items.url;
    return `/${dataApp.lang}${items.url}`;
  };

  const isUrlActive = (items: AccessType) => {
    return document.location.pathname === `/${dataApp.lang}${items.url}`
      ? 'activo'
      : 'noactivo';
  };

  const isUrlActiveMiCuenta = () => {
    const data = miCuenta.filter((items: AccessType) => {
      return document.location.pathname === `/${dataApp.lang}${items.url}`;
    });
    return data.length > 0 ? 'activo' : '';
  };

  if (isClicked) {
    if (showMiCuenta) {
      setShowMiCuenta(false);
    }
    setTimeout(() => {
      setIsClicked(false);
    }, 1000);
  }

  const clickMiCuenta = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMiCuenta(!showMiCuenta);
  };

  const clickLogoEroskiClub = (e: any) => {
    const url = `${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
      'link.eroskies',
    )}eroski-club`;
    e.preventDefault();
    e.stopPropagation();
    GtmManager.sendMenuLinkClickGTM('EROSKI club');
    document.location.href = url;
  };

  const clickLogoCaprabo = (e: any) => {
    // TODO CHANGE THIS
    const url = `${process.env.REACT_APP_CLUB_CAPRABO}${languaje}/clubcaprabo`;
    e.preventDefault();
    e.stopPropagation();
    GtmManager.sendMenuLinkClickGTM('CLUB CAPRABO');
    document.location.href = url;
  };

  document.body.addEventListener(
    'mouseup',
    (e) => {
      const target = e.target as Element;
      if (target.id !== 'dropdown-menu' && showMiCuenta) {
        setShowMiCuenta(false);
      }
    },
    false,
  );
  if (dataUser.user.isApp === 'false' && !isEcommerceBot) {
    if (isEroski) {
      return (
        <>
          <HeaderEroski
            setMenuMobile={setMenuMobile}
            menuMobile={menuMobile}
            clickLogo={clickLogoEroskiClub}
            languaje={languaje}
            setLanguajeHadler={setLanguajeHadler}
            moneda={moneda}
            userName={userName}
            miCuenta={miCuenta}
            ventajas={ventajas}
            getUrl={getUrl}
            isUrlActive={isUrlActive}
            setShowMiCuenta={setShowMiCuenta}
            isUrlActiveMiCuenta={isUrlActiveMiCuenta}
            clickMiCuenta={clickMiCuenta}
            miCuentaText={miCuentaText}
            showMiCuenta={showMiCuenta}
            isClicked={isClicked}
            setIsClicked={setIsClicked}
            solicitarTarjeta={solicitarTarjeta}
            access={access}
            APP_BASE_URL={APP_BASE_URL}
            dataApp={dataApp}
          />
        </>
      );
    }
    if (isCaprabo) {
      return (
        <>
          <HeaderCaprabo
            setMenuMobile={setMenuMobile}
            menuMobile={menuMobile}
            clickLogo={clickLogoCaprabo}
            languaje={languaje}
            setLanguajeHadler={setLanguajeHadler}
            userName={userName}
            miCuenta={miCuenta}
            ventajas={ventajas}
            getUrl={getUrl}
            isUrlActive={isUrlActive}
            setShowMiCuenta={setShowMiCuenta}
            isUrlActiveMiCuenta={isUrlActiveMiCuenta}
            clickMiCuenta={clickMiCuenta}
            miCuentaText={miCuentaText}
            showMiCuenta={showMiCuenta}
            isClicked={isClicked}
            setIsClicked={setIsClicked}
            solicitarTarjeta={solicitarTarjeta}
            access={access}
            APP_BASE_URL={APP_BASE_URL}
            dataApp={dataApp}
          />
        </>
      );
    }
    return <NotFound />;
  }
  return <></>;
};

export default Header;
